import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { httpRequest, queryClient } from '@hc/utils';
import toast from 'react-hot-toast';
import create from 'zustand';

export const constructDrugData = (data) => {
  const allergiesTableData = data.map((val) => ({
    value: val,
    id: val?.id ?? 0,
    relationship: val?.releationship ?? '',
    status: val?.is_active ?? false,
    updated_at: val?.updated_at ?? '',
    created_at: val?.created_at ?? '',
  }));
  return allergiesTableData;
};

export const useRelationships = create((set, get) => ({
  relationshipData: [],
  relationshipCount: 0,
  relationship_id: '',
  relationship: '',
  loading: false,
  error: {
    relationship: '',
  },

  // ------------- STORE METHODS ------------------
  getAllRelationships: async (search = '', limit = 10, offset = 0) => {
    try {
      set({ loading: true });
      const { data } = await queryClient.fetchQuery({
        queryKey: ['getAllRelationships', search, offset],
        queryFn: async () => {
          const response = await httpRequest(
            'get',
            `${envConfig.api_url}/backofficeMaster/relationship/get/all?search=${search}&limit=${limit}&offset=${offset}`,
            {},
            true
          );
          return response;
        },
        staleTime: Infinity,
      });
      if (data?.status?.code === 200) {
        set(() => ({
          relationshipData:
            Array.isArray(data?.data?.relationship_data) &&
            data?.data?.relationship_data?.length > 0
              ? constructDrugData(data?.data?.relationship_data)
              : [],
          relationshipCount: data?.data?.relationship_count,
        }));
      }
      set(() => ({ loading: false }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          '❌ Some thing went wrong plesae try again!'
      );
    }
  },

  relationshipsStatusUpdate: async (payload) => {
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/relationship/status/update`,
        payload,
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? 'Relationships Status Updated Successfully'
        );
      }
      set({ loading: false });
      return data?.status?.code;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
  addEditRelationships: async () => {
    const { relationship, relationship_id: id } = get();
    const type = id ? 'Update' : 'Add';
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/relationship/upsert`,
        { id: id || '', relationship },
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? `Relationships Data ${type} Successfully`
        );
      }
      set({ loading: false });
      return data;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },

  handleChange: (value) => {
    set({ relationship: value });
  },
  isIamValidToSave: () => {
    const { relationship, error } = get();
    if (!relationship) {
      error.relationship = 'Please enter your Relationships name';
    } else {
      error.relationship = '';
      return true;
    }
  },

  initialEditRelationships: (value) => {
    set({
      relationship: value.releationship ?? '',
      relationship_id: value.id ?? '',
    });
  },

  clearRelationshipsData: () => {
    set({
      relationship: '',
      relationship_id: '',
    });
  },
}));
